import { React, useState } from 'react';
import LandingHeader from './header';
import "./landingpage.css"
import mainBG from "../assets/images/svgIcons/landingpage/landingBg.jpg"
import burger from "../assets/images/burger.png"
import Pizza from "../assets/images/pizza12.png"
import nuggets from "../assets/images/nuggets.png"
import sandwich from "../assets/images/sandwich.png"
import Carousel from "react-elastic-carousel";
import { Reviews } from './Mapping';
import ProfileImage from '../assets/images/profileImg.png';
const Review = () => {
    const breakPoints = [
        { width: 0, itemsToShow: 1 },
        { width: 576, itemsToShow: 1 },
        { width: 768, itemsToShow: 2 },
        { width: 992, itemsToShow: 2 },
        { width: 1200, itemsToShow: 3 },
        { width: 1400, itemsToShow: 3 }
    ];
    return (
        <div className=''>
            <div className='center  hadding py-4'>What our Customer said</div>
            <div className='ImageCustomer p-5'>
                <Carousel breakPoints={breakPoints}>
                    {Reviews.map((val) => {
                        return (
                            <div className="row">
                                <div className="col-12 p-lg-4">
                                    <div className="ReviewBG">
                                        <div className="card-body p-4">
                                            <div><img src={val?.Image || ProfileImage} className="icon-m reviewprofile  rounded-circle" /></div>
                                            <h6 className="p-3 center">{val.Description}</h6>
                                            <div className='d-flex'>
                                                <div className=''>
                                                    <div className='center'>- {" "}{val.ArtistName}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </Carousel>
            </div>
        </div>
    );
};

export default Review;
